import React from 'react';
import logo from '../images/allins-logo.png'
import { Link } from "gatsby"

const LogoIcon = () => (
    <Link to="/"><img src={logo} style={{maxWidth:'200px'}} alt="Logo" /></Link>
);

export default LogoIcon;
